import { createAction } from '@reduxjs/toolkit'

export const logout = createAction('layout/logout')
export const clearData = createAction('layout/clearData')
